export default __webpack_public_path__ + "cfd46b1a0a4ac7895ff232318c507ce6.png";